import { render, staticRenderFns } from "./CorporatePR.vue?vue&type=template&id=c69d997c&scoped=true"
import script from "./CorporatePR.vue?vue&type=script&lang=js"
export * from "./CorporatePR.vue?vue&type=script&lang=js"
import style0 from "./CorporatePR.vue?vue&type=style&index=0&id=c69d997c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69d997c",
  null
  
)

export default component.exports